import { EditorDeleteAction } from "./EditorDeleteAction";
export default EditorDeleteAction;
export * from "./EditorDeleteAction";
